/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React, { Fragment } from 'react'

import { EuiFlexGroup, EuiFlexItem } from '@elastic/eui'

import { useConfig } from '@modules/cui/ConfigContext'
import Feature from '@modules/utils/feature'

import SsoSignUp from '@/components/CreateAccountForm/SsoSignUp'

import GoogleSignUp from '../../CreateAccountForm/GoogleSignUp'
import MicrosoftSignUp from '../../CreateAccountForm/MicrosoftSignUp'

import type { FunctionComponent } from 'react'

type Props = {
  redirectTo?: string
  disabled?: boolean
  ssoLoginIdentifier?: string
}

const OpenIdSignUp: FunctionComponent<Props> = ({ redirectTo, disabled, ssoLoginIdentifier }) => {
  const isGovCloud = Boolean(useConfig(Feature.hideIrrelevantSectionsFromGovCloud))

  if (isGovCloud && !ssoLoginIdentifier) {
    // The ESLint disable below is important for returning an empty fragment, which helps ensure that the unit test verifies the component renders correctly.
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <Fragment />
  }

  return (
    <EuiFlexGroup direction='column' gutterSize='m' alignItems='stretch'>
      {!isGovCloud && (
        <Fragment>
          <EuiFlexItem>
            <GoogleSignUp
              fullText={true}
              redirectTo={redirectTo}
              disabled={disabled}
              isCreateUser={true}
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <MicrosoftSignUp
              fullText={true}
              redirectTo={redirectTo}
              disabled={disabled}
              isCreateUser={true}
            />
          </EuiFlexItem>
        </Fragment>
      )}
      {ssoLoginIdentifier && (
        <EuiFlexItem>
          <SsoSignUp ssoLoginIdentifier={ssoLoginIdentifier} />
        </EuiFlexItem>
      )}
    </EuiFlexGroup>
  )
}

export default OpenIdSignUp
